import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { Check, Loader2, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ContractorPurchaseSuccess() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const leadId = searchParams.get("lead_id");
  const [status, setStatus] = useState("loading");
  const navigate = useNavigate();

  useEffect(() => {
    if (!sessionId) {
      setStatus("error");
      return;
    }

    const confirmPurchase = async () => {
      try {
        const response = await axios.get(
          `${API}/contractors/confirm-purchase/${sessionId}`,
          { withCredentials: true }
        );
        
        if (response.data.status === "success") {
          setStatus("success");
        } else {
          setStatus("pending");
          // Retry after delay
          setTimeout(confirmPurchase, 2000);
        }
      } catch (error) {
        if (error.response?.status === 401) {
          navigate("/espace-entrepreneur/login");
        } else {
          setStatus("error");
        }
      }
    };

    confirmPurchase();
  }, [sessionId, navigate]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        {status === "loading" || status === "pending" ? (
          <div data-testid="purchase-loading">
            <div className="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <Loader2 className="w-10 h-10 text-orange-500 animate-spin" />
            </div>
            <h1 className="font-heading text-2xl font-bold text-slate-900 mb-3">
              Confirmation en cours...
            </h1>
            <p className="text-slate-600">
              Veuillez patienter pendant que nous confirmons votre achat.
            </p>
          </div>
        ) : status === "success" ? (
          <div data-testid="purchase-success">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <Check className="w-10 h-10 text-green-600" />
            </div>
            <h1 className="font-heading text-2xl font-bold text-slate-900 mb-3">
              Achat confirmé !
            </h1>
            <p className="text-slate-600 mb-8">
              Le lead a été ajouté à votre liste. Vous pouvez maintenant contacter le client.
            </p>
            <Link to="/espace-entrepreneur">
              <Button className="bg-orange-500 hover:bg-orange-600 text-white">
                Voir mes leads
              </Button>
            </Link>
          </div>
        ) : (
          <div data-testid="purchase-error">
            <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <X className="w-10 h-10 text-red-600" />
            </div>
            <h1 className="font-heading text-2xl font-bold text-slate-900 mb-3">
              Erreur de paiement
            </h1>
            <p className="text-slate-600 mb-8">
              Le paiement n'a pas pu être confirmé. Veuillez réessayer.
            </p>
            <Link to="/espace-entrepreneur">
              <Button className="bg-orange-500 hover:bg-orange-600 text-white">
                Retour au tableau de bord
              </Button>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
